import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {EntityClassSelectorComponent, ExtRetentionTriggerSelectorComponent, VisibleClassifiersMode} from '|shared';
import {SecurityCategoryDto} from '|api/codebook';
import {IczOnChanges, SectionComponent} from '@icz/angular-essentials';
import {IczEmptyDatasource, IczTableDataSource} from '@icz/angular-table';
import {AbstractFileCloseForm} from '../abstract-file-close-form';
import {ReactiveFormsModule} from '@angular/forms';
import {
  CheckboxComponent,
  DatePickerComponent,
  FormAutocompleteComponent,
  FormFieldComponent,
  IczFormContainerDirective
} from '@icz/angular-form-elements';
import {EntityClassDto} from '|api/commons';

@Component({
  selector: 'icz-general-file-close-form',
  templateUrl: './general-file-close-form.component.html',
  styleUrls: ['./general-file-close-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, IczFormContainerDirective, SectionComponent, DatePickerComponent, CheckboxComponent, FormAutocompleteComponent, FormFieldComponent, ExtRetentionTriggerSelectorComponent, EntityClassSelectorComponent]
})
export class GeneralFileCloseFormComponent extends AbstractFileCloseForm implements OnInit, IczOnChanges {

  @Input()
  allEntityClassesDataSource: IczTableDataSource<EntityClassDto> = new IczEmptyDatasource();

  securityCategories: SecurityCategoryDto[] = [];
  entityClasses: EntityClassDto[] = [];

  formGroupsToCheck!: string[];

  readonly VisibleClassifiersMode = VisibleClassifiersMode;
}
